import { Dropdown, Button, Icon } from '@arkas/coreui';
import classnames from 'classnames';
import CustomMenuCarousel from './CustomMenuCarousel';
import CustomMenuSubMenu from './CustomMenuSubMenu';
import { MenuItemDto } from '@emutabakat-types/app';
import React from 'react';

interface CustomMenuItemProps {
  item: MenuItemDto;
  popUpId: string;
}

interface CustomMenuItemStates {
  visible: boolean;
}

/**
 * CustomMenuItem Component
 */
class CustomMenuItem extends React.Component<
  CustomMenuItemProps,
  CustomMenuItemStates
> {
  constructor(props: CustomMenuItemProps) {
    super(props);
    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  wrapperRef: HTMLDivElement | undefined;

  setWrapperRef = (node: HTMLDivElement) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target as HTMLElement)
    ) {
      this.setState({
        visible: false
      });
    }
  };

  togglePopOver = (visible: boolean) => () => {
    this.setState({
      visible
    });
  };

  getPopOverContainer = () => {
    const { popUpId } = this.props;
    return document.getElementById(popUpId) as HTMLElement;
  };

  render() {
    const { item, popUpId } = this.props;
    const { visible } = this.state;

    const subMenu =
      item.items &&
      (item.type === 'mega' ? (
        <CustomMenuCarousel
          carouselItems={item.items}
          togglePopOver={this.togglePopOver}
        />
      ) : (
        <CustomMenuSubMenu
          subMenuItems={item.items}
          togglePopOver={this.togglePopOver(false)}
        />
      ));

    return (
      <div ref={this.setWrapperRef} className="custom-menu-item">
        <div>
          <Dropdown
            overlay={subMenu}
            getPopupContainer={this.getPopOverContainer}
            trigger={['click']}
            visible={visible}
          >
            <Button
              icon={item.icon}
              ghost={true}
              style={{
                height: '100%',
                width: '100%',
                border: 'none',
                display: 'inline-block',
                lineHeight: '36px'
              }}
              onClick={this.togglePopOver(!visible)}
            >
              {item.title}
              <Icon type="down" style={{ fontSize: 10 }} />
            </Button>
          </Dropdown>
          <div
            className={classnames(
              'mega-menu-dropdown',
              item.type === 'mega' && 'full-width'
            )}
            id={popUpId}
          />
        </div>
      </div>
    );
  }
}

export default CustomMenuItem;
